import { useToaster } from 'react-hot-toast'

import { ToastWrapper } from './toast-wrapper'

export const ToastProvider = () => {
    const { toasts, handlers } = useToaster()
    const { startPause, endPause, calculateOffset, updateHeight } = handlers

    return (
        <section
            aria-label="Notifications"
            className="w-8x-large z-toast fixed bottom-0 left-1/2 -translate-x-1/2"
            onMouseEnter={startPause}
            onMouseLeave={endPause}
        >
            {toasts.map((toast) => (
                <ToastWrapper
                    key={toast.id}
                    toast={toast}
                    calculateOffset={calculateOffset}
                    updateHeight={updateHeight}
                />
            ))}
        </section>
    )
}

ToastProvider.displayName = 'ToastProvider'
